import type { Campaign, CampaignOverview, TeamMember } from 'types';
import { CampaignCategory } from 'types/Campaign.type';

export const CAMPAIGN_STATE_PREPARATION = 'preparation';
export const CAMPAIGN_STATE_ACTIVE = 'active';
export const CAMPAIGN_STATE_INACTIVE = 'inactive';
export const CAMPAIGN_STATE_DRAFT = 'draft';
export const CAMPAIGN_CATEGORIES: Array<CampaignCategory> = [
  'accessories',
  'beauty',
  'family',
  'footwear',
  'lingerie',
  'mainstream',
  'outdoor',
  'premium',
  'pride',
  'sports',
  'streetwear',
  'sustainability',
  'other'
];

function checkState(campaign: Campaign | undefined | null, state: string): boolean {
  return (campaign && campaign.state === state || false);
}

export function isPreparation(campaign?: Campaign | null): boolean {
  return checkState(campaign, CAMPAIGN_STATE_PREPARATION);
}

export function isActive(campaign?: Campaign | null): boolean {
  return checkState(campaign, CAMPAIGN_STATE_ACTIVE);
}

export function isInactive(campaign?: Campaign | null): boolean {
  return checkState(campaign, CAMPAIGN_STATE_INACTIVE);
}

export function isDraft(campaign?: Campaign | null): boolean {
  return checkState(campaign, CAMPAIGN_STATE_DRAFT);
}

export function canCampaignBeChanged(campaign?: Campaign | null): boolean {
  if (!campaign || !campaign.state) {
    return false;
  }

  return !isInactive(campaign);
}

export function getCampaignManagersPreview(managers?: Array<TeamMember>): string {
  return (managers || []).map(manager => manager.name).join('; ');
}

export function getCampaignOfferUrl(campaignId: string, overview?: CampaignOverview | null): string {
  const SHORTLISTED_URL = `/campaigns/${campaignId}/participants/shortlisted`;
  const AGREED_URL = `/campaigns/${campaignId}/participants/agreed`;

  if (!overview) {
    return SHORTLISTED_URL;
  }

  const pendingCreators = overview.pendingOverview.creators;
  const acceptedCreators = overview.acceptedOverview.creators;
  const revokedCreators = overview.revokedOverview.creators;

  if (pendingCreators + acceptedCreators + revokedCreators > 0) {
    return AGREED_URL;
  }

  return SHORTLISTED_URL;
}

export function getTotalOffersNumber(campaignOverview?: CampaignOverview | null): number {
  if (!campaignOverview) {
    return 0;
  }

  return campaignOverview.pendingOverview.creators +
    campaignOverview.acceptedOverview.creators +
    campaignOverview.revokedOverview.creators || 0;
}

export function triggerCampaignTutorial(selector: string = '#campaign-tutorial-wrapper') {
  const campaignGuideContainer = document.querySelector(selector);

  if (campaignGuideContainer) {
    const actionButton = campaignGuideContainer.querySelector('.action-button');

    if (actionButton && actionButton instanceof HTMLElement) {
      actionButton.click();
    }
  }
}
